export default __webpack_public_path__ + "static/media/icon-arrow-left.f5980426.svg";